/**
 * @license
 * Copyright Big Vision Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import {LitDemoApp} from './components/lit-demo-app';
import './style.scss';

// tslint:disable-next-line:no-any
(window as any).LitDemoApp = LitDemoApp;
